import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import cx from "classnames";
import { Input } from "../Input";
import { InputIcon } from "../InputIcon";
import styles from "./Search.less";
export var Search =
/*#__PURE__*/
function (_Component) {
  _inherits(Search, _Component);

  function Search() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Search)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      term: String()
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (evt) {
      _this.setState({
        term: evt.target.value
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(_this.props.name, _this.state.term, _this.props.datatype);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      if (_this.props.onSubmit) {
        _this.props.onSubmit(_this.props.name, _this.state.term, _this.props.datatype);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function () {
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(_this.props.name, _this.state.term, _this.props.datatype);
      }
    });

    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        term: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: cx(styles.Search, this.props.className)
      }, React.createElement(Input, _extends({}, this.props, {
        type: "search",
        className: styles.Input,
        onChange: this.onChange
      })), React.createElement(InputIcon, {
        onClick: this.onSubmit
      }, React.createElement("i", {
        className: "fa fa-search"
      })));
    }
  }]);

  return Search;
}(Component);